import type { HttpApiRequestOptions } from '@recruitee/http';
import { HttpRequestData } from '@recruitee/http';

export abstract class IntegrationsHttpRequestData extends HttpRequestData {}

export interface IntegrationHttpApiRequestOptions extends HttpApiRequestOptions {
  context?: string;
}

export interface VideoInterview {
  joinUrl: string;
}
